import '../ styles/user.css'

export const User = ({ name }) => {
  return (
    <div>
      <p className="name"> {name} </p>
    </div>
  );
};
